// extracted by mini-css-extract-plugin
module.exports = {"page-not-found":"page-not-found_page-not-found__u5kn8","title":"page-not-found_title__umMnK","description":"page-not-found_description__1XYII","back":"page-not-found_back__1IYvh"};